import React from 'react';

const features = [
  {
    title: 'Flexible modules',
    description: 'Build a library around your specialty, topic, course, exam, or working routine.',
    path: 'M4 6.75A1.75 1.75 0 0 1 5.75 5h4l1.5 2h7A1.75 1.75 0 0 1 20 8.75v8.5A1.75 1.75 0 0 1 18.25 19H5.75A1.75 1.75 0 0 1 4 17.25V6.75Z',
  },
  {
    title: 'Focused search',
    description: 'Move from a broad question to the right saved material without digging through clutter.',
    path: 'm20 20-4.2-4.2m2.2-5.3a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z',
  },
  {
    title: 'Personal workspace',
    description: 'Keep the resources you return to most arranged around your priorities—not someone else’s.',
    path: 'M4 5.75C4 4.78 4.78 4 5.75 4h12.5C19.22 4 20 4.78 20 5.75v12.5c0 .97-.78 1.75-1.75 1.75H5.75C4.78 20 4 19.22 4 18.25V5.75ZM8 8h8M8 12h5M8 16h7',
  },
  {
    title: 'Cross-device access',
    description: 'Move between web, iPhone, and Android as your setting and available time change.',
    path: 'M8 4.75C8 3.78 8.78 3 9.75 3h4.5C15.22 3 16 3.78 16 4.75v14.5c0 .97-.78 1.75-1.75 1.75h-4.5C8.78 21 8 20.22 8 19.25V4.75ZM11 18h2',
  },
  {
    title: 'Content tools',
    description: 'Create, refine, copy, favorite, and revisit resources in one consistent experience.',
    path: 'M13.5 6.5 17.5 10.5M5 19l3.75-.75L19 8a1.77 1.77 0 0 0-2.5-2.5L6.25 15.75 5 19Z',
  },
  {
    title: 'Sharing controls',
    description: 'Share selected resources with an organization, team, or individual when collaboration matters.',
    path: 'M16 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM8 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm8 8v-2a4 4 0 0 0-4-4H4a4 4 0 0 0-4 4v2m20 0v-2a4 4 0 0 0-3-3.87',
  },
];

const FeaturesSection: React.FC = () => {
  return (
    <section id="features" className="section-shell scroll-mt-20 border-y border-slate-200/80 bg-white">
      <div className="site-container">
        <div className="grid gap-8 lg:grid-cols-[0.75fr_1.25fr] lg:gap-14">
          <div className="max-w-md">
            <p className="section-kicker">Features</p>
            <h2 className="section-title">Less time hunting. More time understanding.</h2>
            <p className="section-copy mt-4">
              1MEDICINE keeps useful information structured, searchable, and ready to
              pick up again—without turning your library into another source of noise.
            </p>
            <a
              href="https://1medicine.app"
              target="_blank"
              rel="noopener noreferrer"
              className="secondary-button mt-7"
            >
              Explore the app
              <svg aria-hidden="true" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 17 17 7M7 7h10v10" />
              </svg>
            </a>
          </div>

          <div className="grid gap-3 sm:grid-cols-2">
            {features.map((feature) => (
              <article key={feature.title} className="surface-card flex gap-4 p-5">
                <span className="soft-icon shrink-0">
                  <svg aria-hidden="true" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.7} d={feature.path} />
                  </svg>
                </span>
                <div>
                  <h3 className="font-semibold text-slate-900">{feature.title}</h3>
                  <p className="mt-1.5 text-sm leading-6 text-slate-600">{feature.description}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
